import React from 'react';
import { ToggleButton, ToggleButtonGroup, type SxProps, type Theme } from '@mui/material';

type Option = { label: string; value: string };

type Props = {
  options: readonly Option[];
  /** 現在値（未選択は ''） */
  value: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

/**
 * ラジオよりタップ範囲が広く、現在値が見やすい2〜3択トグル。
 * 同じボタンの再押下による null（選択解除）は無視し、必須項目が誤って外れるのを防ぐ。
 */
const IntakeToggleGroup: React.FC<Props> = ({ options, value, onChange, ariaLabel, disabled, sx }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    color="primary"
    value={value || null}
    disabled={disabled}
    onChange={(_, v) => {
      if (v != null) onChange(v);
    }}
    aria-label={ariaLabel}
    sx={[
      {
        flexWrap: 'wrap',
        '& .MuiToggleButton-root': { px: 1.5, py: 0.125, lineHeight: 1.3, minHeight: 28 },
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {options.map((o) => (
      <ToggleButton key={o.value} value={o.value}>
        {o.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default IntakeToggleGroup;
